import {Component, OnInit } from '@angular/core';
import { ApiContentService } from '../../api/api-content.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiLoginService } from '../../api/api-login.service';
// import { navItems } from '../../_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  // public navItems = navItems;
  userlogin:any=[]
  username:any=[]

  constructor(
		public restservice:ApiContentService,
    private router: Router,
    private rest: ApiLoginService, 
  ) { }
  
  toggleMinimize(e:any) {
    this.sidebarMinimized = e;
  }

  navItems:any = [];

  // navItems:any = [{
  //                   name: 'Dashboard',
  //                   url: '/dashboard',
  //                   icon: 'icon-speedometer',
  //                   badge: {
  //                     variant: 'info',
  //                     text: 'NEW'
  //                   }
  //                 },
  //                 {
  //                   name: 'Buttons',
  //                   url: '/buttons',
  //                   icon: 'icon-cursor',
  //                   children: [
  //                     {
  //                       name: 'Buttons',
  //                       url: '/buttons/buttons',
  //                       icon: 'icon-cursor'
  //                     },
  //                     {
  //                       name: 'Dropdowns',
  //                       url: '/buttons/dropdowns',
  //                       icon: 'icon-cursor'
  //                     },
  //                     {
  //                       name: 'Brand Buttons',
  //                       url: '/buttons/brand-buttons',
  //                       icon: 'icon-cursor'
  //                     }
  //                   ]
  //                 }];
  
  getMenu() {
    
    this.restservice.getMenu().subscribe((response: any) => {
      // console.log(response);
      this.navItems = response.data;
      // this.navItems = [{
      //                     name: 'Buttons',
      //                     url: '/buttons',
      //                     icon: 'icon-cursor',
      //                     children: [
      //                       {
      //                         name: 'Buttons',
      //                         url: '/buttons/buttons',
      //                         icon: 'icon-cursor'
      //                       },
      //                       {
      //                         name: 'Dropdowns',
      //                         url: '/buttons/dropdowns',
      //                         icon: 'icon-cursor'
      //                       },
      //                       {
      //                         name: 'Brand Buttons',
      //                         url: '/buttons/brand-buttons',
      //                         icon: 'icon-cursor'
      //                       }
      //                     ]
      //                   }];
      // console.log(response);
    });

  }

  ngOnInit() {
    this.getMenu()
    this.ceklogin()
  }
  ceklogin() {
    this.userlogin = this.rest.currentUserValue
    if(this.userlogin.status){
      this.username = this.userlogin.data.username
    }
    console.log(this.userlogin)
  }

  logout() {
    this.rest.logout()
    this.router.navigate(['login'])
  }
}
